module.exports = __webpack_public_path__ + "img/Payel-pal.101cec70.jpeg";